/** Deposits page and deposit drawer. */
export const deposits = {
  title: "Deposits",
  intro: "Every incoming transfer to your players' deposit addresses. Amounts are in token units; fees are taken on confirmation.",
  searchLabel: "Search player ref, username, address or tx hash",
  searchHint: "Player ref / username / request ID match from the start; paste a full address or tx hash.",
  emptyFilteredTitle: "No deposits match",
  emptyFilteredBody: "{hint} Try a wider date range or clear a filter.",
  emptyTitle: "No deposits yet",
  emptyBody: "When players send USDT or USDC to their deposit addresses, they show up here.",
  /** Screen-reader label for a row; {status} is the API status code. */
  rowLabel: "Deposit {amount} {token} from {player}, {status}",

  // Table columns and drawer details
  time: "Time",
  playerRef: "Player ref",
  amount: "Amount",
  fee: "Fee",
  net: "Net",
  txHash: "Tx hash",
  netCredited: "Net credited",
  network: "Network",
  finality: "Finality",
  depositAddress: "Deposit address",
  block: "Block",
  logIndex: "Log index",
  detected: "Detected",
  confirmed: "Confirmed",
  depositId: "Deposit ID",

  // Drawer
  drawerTitle: "Deposit",
  flaggedNote: "This deposit didn't match on our second RPC provider and is held for review. It isn't credited yet.",
  flaggedRiskNote: "The sender's wallet is linked to high-risk funds (for example sanctioned, stolen or laundered USDT). This deposit is not credited and stays on the player's deposit address, apart from your vault. Contact us if you believe this is a mistake.",
  riskReason: "Risk found",
  orphanedNote: "The block with this transfer was dropped by a chain reorganisation. It was not credited.",
  belowMinNote: "The amount is below your minimum deposit, so it wasn't credited.",
  viewOnExplorer: "View on block explorer",
};
